// The error codes GET /api/export-file/contact-tracing answers with as plain text.
export function getContactTracingExportMessage(code: string | undefined): string {
  switch (code) {
    case 'CONTACT_TRACING_EXPORT_CASE_ID_REQUIRED':
      return 'Indexpatient muss angegeben werden';
    case 'CONTACT_TRACING_EXPORT_CASE_ID_INVALID':
      return 'Die ID des Indexpatienten ist ungültig';
    case 'CONTACT_TRACING_EXPORT_CASE_NOT_FOUND':
      return 'Der Indexpatient wurde nicht gefunden';
    case 'CONTACT_TRACING_EXPORT_CASE_NOT_INDEX':
      return 'Der ausgewählte Patient ist kein Indexfall';
    case 'CONTACT_TRACING_EXPORT_CASE_NUMBER_MISSING':
      return 'Der Indexpatient hat keine Fallnummer, die Kontaktliste kann nicht exportiert werden';
    default:
      return 'Beim Exportieren der Kontaktliste ist ein Fehler aufgetreten';
  }
}
